const calculateIconScale = (baseScale, zoomLevel) => {
    if (zoomLevel < 17) {
        return baseScale + (zoomLevel - 20) * 0.13;
    } else {
        return baseScale + (zoomLevel - 20) * 0.09;
    }
};

export default calculateIconScale;
